import {UserManager} from "oidc-client";
import {logger} from "../common/logger";

let userManager:UserManager;

let vanillaFetch = window['fetch'];

let authenticatedFetch: (input:RequestInfo,init?:RequestInit)=>Promise<Response>;

export function configureFetch(manager:UserManager|null){
    if (!manager) {
        throw "User not authenticated. Please call thus function post authentication"
    }
    if (!userManager){
        userManager = manager;    
    }
    authenticatedFetch = async (input:RequestInfo,init:RequestInit|undefined)=>{
        let user=await userManager.getUser();
        if (!user || user?.expired) {
            user = await userManager.signinSilent();
        }
        let authInit={
            ...(init || {}),
            "headers":{
                'Authorization':`${user.token_type} ${user.access_token}`,
                'Content-Type' : 'application/json-patch+json'
            }
            
        };
        try {
            let res =  await vanillaFetch(input,authInit);
            if(!res.ok){
                if (res.status===422){
                    throw await res.json();
                }
                throw await res.text();
            }
            return res;
        } catch (error) {
            return Promise.reject(error);
        }
        
    };
}

export {authenticatedFetch};